import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["queryReference", "children"];
import _hubBootstrapQuery from "./__generated__/hubBootstrapQuery.graphql";
/* eslint-disable @atlassian/relay/unused-fields */
import React from 'react';
import { graphql, usePreloadedQuery } from 'react-relay';
import { DEFAULT_BRANDING_COLOR } from '../../constants';
import { HubContext } from '../../utils';
import HubBootstrapQuery from './__generated__/hubBootstrapQuery.graphql';
export var HubBootstrap = function HubBootstrap(_ref) {
  var _data$tenantContexts$, _data$tenantContexts, _data$helpCenter$help, _branding$colors$prim, _branding$colors, _queryReference$varia;
  var queryReference = _ref.queryReference,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var data = usePreloadedQuery(_hubBootstrapQuery, queryReference);
  var cloudUrl = (_data$tenantContexts$ = (_data$tenantContexts = data.tenantContexts) === null || _data$tenantContexts === void 0 || (_data$tenantContexts = _data$tenantContexts[0]) === null || _data$tenantContexts === void 0 ? void 0 : _data$tenantContexts.cloudUrl) !== null && _data$tenantContexts$ !== void 0 ? _data$tenantContexts$ : window.location.origin;
  if (!data.helpCenter) {
    throw new Error('Help center not found');
  }
  var branding = (_data$helpCenter$help = data.helpCenter.helpCenterById) === null || _data$helpCenter$help === void 0 ? void 0 : _data$helpCenter$help.helpCenterBranding;
  var logo = branding === null || branding === void 0 ? void 0 : branding.logo;
  var primaryColor = (_branding$colors$prim = branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary) !== null && _branding$colors$prim !== void 0 ? _branding$colors$prim : undefined;
  var fileId = (logo === null || logo === void 0 ? void 0 : logo.fileId) || '';
  var url = (logo === null || logo === void 0 ? void 0 : logo.url) || '';
  var cloudId = (_queryReference$varia = queryReference.variables) === null || _queryReference$varia === void 0 ? void 0 : _queryReference$varia.cloudId;
  return /*#__PURE__*/React.createElement(HubContext.Provider, {
    value: {
      pageMediaConfig: data.helpCenter.pageMediaConfig,
      hubMediaConfig: data.helpCenter.hubMediaConfig,
      branding: {
        logo: {
          fileId: fileId,
          url: url
        },
        colors: {
          primary: primaryColor || DEFAULT_BRANDING_COLOR
        }
      },
      layout: props.layout,
      user: props.user,
      env: props.env,
      actions: props.actions,
      renderRightNavActions: props.renderRightNavActions,
      cloudId: cloudId,
      cloudUrl: cloudUrl
    }
  }, children);
};
export { HubBootstrapQuery };